import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BookingOverviewGuests from '../components/bookingOverview/BookingOverviewGuests';

class BookingOverviewGuestsContainer extends Component {
  static fillArrayWithNumbers(n) {
    return [...Array(n + 1).keys()];
  }

  static calculateGuests(order, rental) {
    const availability = {
      availableAdults: [],
      availableChildren: [],
      availablePets: [],
    };

    availability.availablePets = BookingOverviewGuestsContainer.fillArrayWithNumbers(rental.information.allowedPetCount);

    let maxAdults = rental.information.adultCount;
    // calculate how many of the children use child beds and how many needs adult beds.
    const childOverflow = order.children - rental.information.childrenCount;
    if (childOverflow > 0) {
      maxAdults = rental.information.adultCount - childOverflow;
    }
    availability.availableAdults = BookingOverviewGuestsContainer.fillArrayWithNumbers(maxAdults);
    // make sure to not show 0, if we have already selected more than 0 adults
    if (order.adults > 0) {
      availability.availableAdults.shift();
    }

    let maxChildren = rental.information.childrenCount + rental.information.adultCount - order.adults;
    if (order.adults === 0) {
      // if we are setting the children array, always make sure to have space for at least 1 adult
      maxChildren--;
    }
    availability.availableChildren = BookingOverviewGuestsContainer.fillArrayWithNumbers(maxChildren);

    return availability;
  }

  render() {
    const {availableAdults, availableChildren, availablePets}
      = BookingOverviewGuestsContainer.calculateGuests(this.props.order,
        this.props.rental);

    return (
      <BookingOverviewGuests
        availableAdults={availableAdults}
        availableChildren={availableChildren}
        availablePets={availablePets}
        errors={this.props.errors}
        order={this.props.order}
        rental={this.props.rental}
        updateAdditionalChildren={this.props.actions.updateAdditionalChildren}
        updateGuests={this.props.actions.updateGuests}
      />
    );
  }
}

BookingOverviewGuestsContainer.PropTypes = {
  appearance:PropTypes.object.isRequired,
  order:PropTypes.object.isRequired,
  rental:PropTypes.object.isRequired,
  errors:PropTypes.object.isRequired,
  actions:PropTypes.object.isRequired,
};

export default BookingOverviewGuestsContainer;
